import { combineEpics, ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { catchError, delay, mergeMap } from 'rxjs/operators';

import { TAB_CHANGE } from 'actionTypes/appDrawer';
import {
  SUBSCRIBE_L2_ORDERBOOK,
  SUBSCRIBE_RECENT_TRADE,
  UNSUBSCRIBE_L2_ORDERBOOK,
  UNSUBSCRIBE_OB_RT,
} from 'actionTypes/socket';
import { APP_DRAWER_TAB_ID_MAPPING } from 'reducers/initialstate/appDrawer';
import { selectedProductState } from 'selectors/tradeSelectors';
import { CustomAction } from 'types/Istore';

let lastProductSymbol: string | null = null;
const UNSUBSCRIBE_DEBOUNCE_MS = 5000;

type TabChangeAction = {
  type: string;
  payload:
    | string
    | {
        subscribeUID?: string;
        symbol?: string;
        resolution?: string;
      };
};

const unsubscribeChannelsOnPositionsTabEpic = (action$: CustomAction, state$) =>
  action$.pipe(
    ofType(TAB_CHANGE),
    mergeMap(action => {
      // @ts-ignore - ts issue with lib
      const activeTab = action.payload;

      // #region When switching TO "tabpositions" - unsubscribe (with 5s debounce) l2obr and agg_trades
      if (activeTab === APP_DRAWER_TAB_ID_MAPPING.POSITIONS) {
        const selectedProduct = selectedProductState(state$.value);
        const productSymbol = selectedProduct?.symbol ?? null;

        lastProductSymbol = productSymbol;

        const actions: TabChangeAction[] = [];

        // Add L2 orderbook unsubscribe if product symbol exists
        if (productSymbol) {
          actions.push({
            type: UNSUBSCRIBE_L2_ORDERBOOK,
            payload: productSymbol,
          });
          actions.push({
            type: UNSUBSCRIBE_OB_RT,
            payload: productSymbol,
          });
        }

        return of(...actions).pipe(delay(UNSUBSCRIBE_DEBOUNCE_MS));
      }

      // #endregion

      // #region When switching TO "tabChartOrderbook" || "tabtrade" tab - resubscribe l2obr and agg_trades
      if (
        activeTab === APP_DRAWER_TAB_ID_MAPPING.CHART_ORDERBOOK ||
        activeTab === APP_DRAWER_TAB_ID_MAPPING.TRADE
      ) {
        const actions: TabChangeAction[] = [];

        // Resubscribe to L2 orderbook and recent trades if we have the product symbol
        if (lastProductSymbol) {
          actions.push({
            type: SUBSCRIBE_L2_ORDERBOOK,
            payload: lastProductSymbol,
          });
          actions.push({
            type: SUBSCRIBE_RECENT_TRADE,
            payload: lastProductSymbol,
          });
        }

        lastProductSymbol = null;

        return of(...actions);
      }

      // #endregion
      return EMPTY;
    }),
    catchError(err => {
      console.error('SOCKET CHANNEL SUBSCRIPTION MANAGEMENT ON POSITION TAB CHANGE', err);
      return EMPTY;
    })
  );

export default combineEpics(unsubscribeChannelsOnPositionsTabEpic);
